import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Box } from '@material-ui/core';

import TicketIcon from '../../common/icons/ticketIcon';
import ContactForm from './ContactForm';
import ProfileTitle from '../../layout/mobile/profile/ProfileTitle';
import TicketContainer from './desktop/TicketContainer';
import TicketContainerMobile from './mobile/TicketContainerMobile';
import ErrorState from '../../common/errorState/errorState';
import { showTicketsOrForm } from '../../../helpers/tickets/TicketsHelper';
import { getTickets } from '../../../redux/actions/TicketActions';
import { ticketListMessages } from '../../../constants/Messages';

const MyTickets = ({ ...props }) => {
  const { path, mobile } = props;
  const profile = useSelector((state) => state.profileReducer.profile);
  const location = useLocation();
  const dispatch = useDispatch();
  const { tickets, ticketStatus } = useSelector((state) => state.ticketReducer);
  const [error, setError] = useState(false);
  const catchError = () => {
    setError(true);
  };

  useEffect(() => {
    showTicketsOrForm() &&
      ticketStatus !== 'succeded' &&
      dispatch(getTickets());
  }, []);

  return (
    <React.Fragment>
      {showTicketsOrForm() ? (
        <Box>
          <ProfileTitle
            mobile={mobile}
            title={<strong>{ticketListMessages.title}</strong>}
            subtitle={ticketListMessages.subtitle}
            icon={<TicketIcon size="30px" color="#6a148e" />}
          />
          {!mobile && (
            <TicketContainer tickets={tickets} ticketStatus={ticketStatus} />
          )}
          {mobile && (
            <TicketContainerMobile
              tickets={tickets}
              ticketStatus={ticketStatus}
            />
          )}
        </Box>
      ) : (
        <React.Fragment>
          {!error && (
            <ContactForm
              location={location}
              containerState={{ ...profile }}
              containerPath={path}
              catchError={catchError}
            />
          )}
          {error && (
            <ErrorState
              mobile={mobile}
              title="Por ahora el servicio de Solicitudes no está disponible"
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

MyTickets.propTypes = {
  path: PropTypes.string,
  mobile: PropTypes.bool,
};

export default MyTickets;
